import React, { Component, Fragment } from 'react';
import { Col, FormGroup, Label } from 'reactstrap';
import Select from 'react-select';
import { vitalsOptions } from '../configData'
import BloodSugarTable from './BloodSugarTable';
import BloodPressureTable from './BloodPressureTable';
import ThyroidTable from './ThyroidTable';
import { getThyroidRecord, getBloodPressureRecord, getBloodSugarRecord } from '../../services'

class ShareVitals extends Component {

  state = {
    vitals: null
  }

  handleVitals = async (selectedOption) => {
    let response;
    if(selectedOption['value'] == 1) {
      response = await getThyroidRecord();
    } else if(selectedOption['value'] == 2) {
      response = await getBloodSugarRecord();
    } else if(selectedOption['value'] == 3) {
      response = await getBloodPressureRecord();
    }
    this.setState(prevState => ({
      vitals: selectedOption['value'],
      record: response.data.record
    }))
  }

  renderTableHeader = () => {
    const { vitals, record } = this.state;
    if(vitals == 1) {
      return <ThyroidTable records={record} model="3"/>
    } else if(vitals == 2) {
      return <BloodSugarTable records={record} model="4"/>
    } else if(vitals == 3) {
      return <BloodPressureTable records={record} model="5"/>
    }
  }

  render () {

    const { vitals } = this.state

    return (
      <Fragment>
        <Col md="4">
          <FormGroup>
            <Label>Select vitals type</Label>
            <Select 
              options={vitalsOptions}
              onChange={this.handleVitals}
            />
          </FormGroup>
        </Col>
        {vitals != null && 
        <Col md="12">
          {this.renderTableHeader()}
        </Col>}
      </Fragment>
    )
  }
}

export default ShareVitals;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ShareMyRecord/ShareVitals.js